import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateAuthoringLegislationGroup = api(async function updateAuthoringLegislationGroup({ id, group }) {
    return mutate(
        gql`
            mutation UpdateAuthoringLegislationGroup($id: String!, $group: AuthoringLegislationGroupInput!) {
                updateAuthoringLegislationGroup(id: $id, group: $group) {
                    id
                    legacyId
                    name
                    parentId
                    lastModified
                }
            }
        `,
        { id, group },
        { returns: "updateAuthoringLegislationGroup" }
    )
})
